var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 24.1875C10.7625 24.1875 12.5625 22.3875 12.5625 20.1562V16.125H8.53125C6.3 16.125 4.5 17.925 4.5 20.1562C4.5 22.3875 6.3 24.1875 8.53125 24.1875Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.0938C4.5 9.8625 6.3 8.0625 8.53125 8.0625H12.5625V16.125H8.53125C6.3 16.125 4.5 14.325 4.5 12.0938Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.03125C4.5 1.8 6.3 0 8.53125 0H12.5625V8.0625H8.53125C6.3 8.0625 4.5 6.2625 4.5 4.03125Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 0H16.5938C18.825 0 20.625 1.8 20.625 4.03125C20.625 6.2625 18.825 8.0625 16.5938 8.0625H12.5625V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 12.0938C20.625 14.325 18.825 16.125 16.5938 16.125C14.3625 16.125 12.5625 14.325 12.5625 12.0938C12.5625 9.8625 14.3625 8.0625 16.5938 8.0625C18.825 8.0625 20.625 9.8625 20.625 12.0938Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.3bdc9a5958c18bdea7f1c5312db0873e.svg";
export { ForwardRef as ReactComponent };